module.exports = __webpack_public_path__ + "img/gift_top-orange_podium.c212e7b3.png";